<template>
  <div
    class="upload-box"
    @dragover="preventDefault"
    @drop.prevent="fileDropped"
    @dragleave="preventDefault"
  >
    <h2 class="h3">
      {{ $t('Upload.dropHere') }}
    </h2>
    <div class="text-center upload-info" v-html="$t('Upload.uploadInfo')" />
    <img src="~images/icon__docs.svg" alt="Icon document">
    <div class="actions">
      <p v-if="inProgress" v-html="message || $t('Upload.uploading')" />
      <p v-if="failed" v-html="message || $t('Upload.problem')" />

      <template v-if="existingProjectUrl">
        <p
          class="text-center"
          v-html="$t('Upload.existingProject', { url: existingProjectUrl })"
        />
        <div class="notice-buttons">
          <a class="button primary" href="/users/sign_in">
            {{ $t('Upload.existingProjectLogin') }}
          </a>
          <span>{{ $t('Upload.or') }}</span>
          <a class="button primary" href="/users/sign_up">
            {{ $t('Upload.existingProjectRegister') }}
          </a>
        </div>
      </template>

      <progress
        v-if="inProgress"
        class="success"
        max="100"
        :value="progress"
      />

      <form name="upload" class="hidden">
        <input
          ref="filePicker"
          id="file"
          type="file"
          name="file"
          @change="fileSelected"
        >
      </form>

      <template v-if="!inProgress && !existingProjectUrl">
        <a class="button large primary" @click.prevent="selectFile" href="#">
          {{ $t('Upload.selectFile') }}
        </a>
        <p class="text-center">
          <small>
            <i class="fas fa-lock" />&nbsp;{{ $t('Upload.secureUpload') }}
          </small>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import messages from 'locales/Upload';
import { mapState, mapActions } from 'vuex';
import { pageUrl } from 'helper/clientDetails';

export default {
  computed: {
    ...mapState(['inProgress', 'failed', 'message', 'progress', 'existingProjectUrl']),
  },
  methods: {
    ...mapActions(['upload']),
    selectFile() {
      this.$refs.filePicker.click();
    },
    fileSelected(evt) {
      window.plausible('drop_zone_upload', { u: pageUrl(), props: { method: 'file-picker' } });
      this.upload(Array.from(evt.target.files));
    },
    fileDropped(evt) {
      window.plausible('drop_zone_upload', { u: pageUrl(), props: { method: 'drop' } });
      this.upload(Array.from(evt.dataTransfer.files));
    },
    preventDefault(evt) {
      evt.preventDefault();
      evt.stopPropagation();
    },
  },
  i18n: { messages },
};
</script>

<style lang="scss" scoped>
.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  .actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .notice-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.5rem 1rem;

    .button {
      margin-bottom: 0;
    }
  }
}
</style>
